var map = {
	"./icon-assessment.svg": 4880,
	"./icon-astreya.svg": 5182,
	"./icon-coaching.svg": 4881,
	"./icon-comprehensive-company.svg": 4882,
	"./icon-ct-arrow.svg": 4883,
	"./icon-ct-check.svg": 4884,
	"./icon-ct-cross.svg": 4885,
	"./icon-customization.svg": 4886,
	"./icon-customized-plan.svg": 4887,
	"./icon-graduation.svg": 4888,
	"./icon-industry-content.svg": 4889,
	"./icon-moneco.svg": 5183,
	"./icon-onboarding-call.svg": 4890,
	"./icon-perfacct.svg": 5184,
	"./icon-quote.svg": 4891,
	"./icon-stars-review.svg": 4892,
	"./icon-training.svg": 4893,
	"./icon-workshops.svg": 4894
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5181;